export const PERMISSION_SECTION_ORDER = [
  "tenants",
  "users",
  "ghost",
  "governance",
  "catalog",
  "commercial",
  "operations",
  "analytics",
];

export const PERMISSION_SECTION_LABELS = {
  tenants: "Tenants",
  users: "Users",
  ghost: "Ghost",
  governance: "Governance",
  catalog: "Catalog",
  commercial: "Commercial",
  operations: "Operations",
  analytics: "Analytics",
};

export const PERMISSION_DOMAIN_SECTION = {
  dashboard: "tenants",
  tenant: "tenants",
  prospect: "users",
  user: "users",
  session: "users",
  ghost: "ghost",
  audit: "governance",
  staff: "governance",
  roles: "governance",
  catalog: "catalog",
  billing: "commercial",
  plans: "commercial",
  integrations: "operations",
  jobs: "operations",
  usage: "analytics",
};

export const OWNER_LOCKED_MESSAGE = "The Platform Owner role cannot be modified.";
export const BUILT_IN_DELETE_MESSAGE = "Built-in platform roles cannot be deleted.";
export const MEMBERS_DELETE_MESSAGE =
  "Cannot delete a role with assigned members. Reassign staff first.";
export const ESCALATION_GUARD_MESSAGE = "Cannot grant permissions you do not hold.";

export const buildPermissionSections = (permissionGroups = {}) => {
  const sectionMap = new Map(
    PERMISSION_SECTION_ORDER.map((key) => [key, { key, label: PERMISSION_SECTION_LABELS[key], permissions: [] }])
  );

  Object.entries(permissionGroups || {}).forEach(([domain, permissions]) => {
    const sectionKey = PERMISSION_DOMAIN_SECTION[domain] || "governance";

    if (!sectionMap.has(sectionKey)) {
      sectionMap.set(sectionKey, {
        key: sectionKey,
        label: PERMISSION_SECTION_LABELS[sectionKey] || sectionKey,
        permissions: [],
      });
    }

    (permissions || []).forEach((permission) => {
      sectionMap.get(sectionKey).permissions.push({
        ...permission,
        checked: Boolean(permission.status),
      });
    });
  });

  return PERMISSION_SECTION_ORDER.map((key) => sectionMap.get(key)).filter(
    (section) => section.permissions.length > 0
  );
};

export const togglePermissionSelection = (sections, permissionId) =>
  sections.map((section) => ({
    ...section,
    permissions: section.permissions.map((permission) => {
      if (permission.id !== permissionId) {
        return permission;
      }

      if (!permission.grantable) {
        return permission;
      }

      return { ...permission, checked: !permission.checked };
    }),
  }));

export const getSelectedPermissionIds = (sections) =>
  sections.flatMap((section) =>
    section.permissions.filter((permission) => permission.checked).map((permission) => permission.id)
  );

export const getDeleteBlockReason = (role) => {
  if (!role) {
    return "Role not found.";
  }

  if (role.is_platform_owner) {
    return OWNER_LOCKED_MESSAGE;
  }

  if (role.is_built_in) {
    return BUILT_IN_DELETE_MESSAGE;
  }

  if ((role.members_count || 0) > 0) {
    return MEMBERS_DELETE_MESSAGE;
  }

  return null;
};

export const canEditRoleName = (role) => Boolean(role && !role.is_built_in);

export const DEFAULT_ROLE_FILTERS = {
  search: "",
  page: 1,
  perPage: 25,
};

export const buildRolesListQuery = (
  filters,
  basePath = "super-admin/roles-and-permission/roles"
) => {
  const params = new URLSearchParams();

  if (filters.search) {
    params.append("search", filters.search);
  }

  params.append("page", String(filters.page || 1));
  params.append("per_page", String(filters.perPage || 25));

  const query = params.toString();
  return query ? `${basePath}?${query}` : basePath;
};

